import React from 'react';
import ReactDOM, { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router } from "react-router-dom";
import { UserProvider } from './context/connexion/userConnext';
import { BaseProvider } from './context/connexion/baseConnexion';
import { TokenProvider } from './context/connexion/token/token';
import { ConfProvider } from './context/account/paramsAccount';
import { PrestaProvider } from './context/presta/fichePresta';
import { ErrorProvider } from './context/erreur/erreurContext';
import { OfflineModeProvider } from './context/horsLigne/modeHorsLigneContext';
import { ModalProvider } from './context/modal/modalContext';

const rootElement = document.getElementById("root");
if (rootElement) {
  const root = createRoot(rootElement);
  root.render(
    <Router>
      <UserProvider>
        <BaseProvider>
          <TokenProvider>
            <ConfProvider >
              <PrestaProvider>
                <OfflineModeProvider>
                  <ErrorProvider>
                    <ModalProvider>
                      <App />
                    </ModalProvider>
                  </ErrorProvider>
                </OfflineModeProvider>
              </PrestaProvider>
            </ConfProvider>
          </TokenProvider>
        </BaseProvider>
      </UserProvider>
    </Router>
  );
}
